import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Divider,
  Box,
  Icon,
  Text,
} from "@chakra-ui/react";
import { MdAttachMoney } from "react-icons/md";
import InstallmentTable from "./InstallmentTable";
import { Installment } from "@/models/proposal.model";

type ResultModalProps = {
  isOpen: boolean;
  onClose: () => void;
  installments: Installment[];
};

export default function InstallmentModal({
  isOpen,
  onClose,
  installments,
}: ResultModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center">
            <Icon as={MdAttachMoney} w={6} h={6} color="blue.600" mr={2} />
            <Text fontSize="xl" fontWeight="bold" color="gray.700">
              Quantidade de Anos Antecipados
            </Text>
          </Box>
          <Button
            variant="ghost"
            colorScheme="blue"
            onClick={onClose}
            size="sm"
          >
            Fechar
          </Button>
        </ModalHeader>

        <Divider borderColor="gray.300" mb={4} />

        <ModalBody>
          <InstallmentTable
            installments={installments}
          />
        </ModalBody>

        <Divider borderColor="gray.300" mt={4} />

        <ModalFooter>
          <Button colorScheme="green" onClick={onClose}>
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
